import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ReactDOM from 'react-dom';

import FormattedSummary from './FormattedSummary';
import { Link } from 'react-router-dom';

// Utility to render different media types inline or fallback to download links
function renderMedia(url) {
  const ext = url.split('.').pop().toLowerCase();
  if (['jpg','jpeg','png','gif','svg','webp'].includes(ext)) {
    return <img src={url} alt="Media" style={{  maxHeight: '100%' }} />;
  }
  if (['mp4','webm','ogg'].includes(ext)) {
    return (
      <video controls style={{ maxWidth: '100%' }}>
        <source src={url} type={`video/${ext}`} />
        Your browser doesn’t support this video format.
      </video>
    );
  }
  if (['mp3','wav','ogg'].includes(ext)) {
    return <audio controls src={url}>Your browser doesn’t support this audio format.</audio>;
  }

  if (ext === 'pdf') {
    return (
      <p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ 
            display: 'inline-block', 
            padding: '0.5em 1em', 
            background: '#007bff', 
            color: '#fff', 
            borderRadius: '4px',
            textDecoration: 'none'
          }}
        >
          View PDF in new tab
        </a>
      </p>
    );
  }
  // Fallback for any other file types
  return (
    <p>
      <a href={url} target="_blank" rel="noopener noreferrer">
        Download file
      </a>
    </p>
  );
}

function CaseScores() {
  const { id } = useParams();
  const [caseData, setCaseData] = useState(null);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    const fetchCaseScores = async () => {
      try {
        const response = await axios.get(`/cases/${id}/scores`, { withCredentials: true });
        setCaseData(response.data);
        if (Array.isArray(response.data.images) && response.data.images.length > 0) {
          setImages(response.data.images);
          // setCurrentImage(response.data.images[0]); // Set the first image as current
        }
      } catch (err) {
        setError('Failed to fetch case scores');
        console.error(err);
      }
    };

    fetchCaseScores();
  }, [id]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!caseData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container">
      <h1 className="text-3xl font-bold mb-6">{caseData.title} - Scores</h1>
      <table className="critical-actions-grid">
        <thead>
          <tr>
            <th>Critical Action</th>
            {caseData.attempts.map((_, index) => (
              <th key={index}>Attempt {index + 1}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {caseData.criticalActions.map((action) => (
            <tr key={action}>
              <td>{action}</td>
              {caseData.attempts.map((attempt, index) => (
                <td key={index}>
                  {attempt.completedCriticalActions.includes(action) ? '✔️' : ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      { /* Images Section */}
      {images.length > 0 && (
        <div className="image-buttons mb-6">
          {images.map((url, i) => (
            <button
              key={i}
              onClick={() => setCurrentImage(url)}
              className="btn btn-secondary m-2"
            >
              Media {i + 1}
            </button>
          ))}
        </div>
      )}
      <div id="summary-container"></div>      {/* Summary Section */}
      <div className="mt-6">
        <h2 className="text-2xl font-bold mb-4">Case Summary</h2>
        {caseData.summary ? (
          <FormattedSummary summary={caseData.summary} />
        ) : (
          <p>No summary available for this case.</p>
        )}
      </div>    
            {/* Dashboard Button */}
            <div style={{ marginTop: '30px' }}>
        <Link to="/dashboard">
          <button   style={{
            padding: '12px 24px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
          }}>
            Back to Dashboard
          </button>
        </Link>
      </div>

               {currentImage && (
            <div style={{ position:'fixed', top:0, left:0, width:'100vw', height:'100vh', backgroundColor:'rgba(0,0,0,0.8)', display:'flex', justifyContent:'center', alignItems:'center', padding:'1rem', zIndex:1000 }}>
              <div style={{ position:'relative', maxWidth:'800px', height:'100%', maxHeight:'90vh' }}>
                <button onClick={() => setCurrentImage(null)} style={{ position:'absolute', top:'-1.1rem', right:'-1rem', backgroundColor:'rgba(0,0,0,0.8)', color:'#fff', border:'none', borderRadius:'50%', width:'35px', height:'35px', fontSize:'18px', cursor:'pointer', zIndex:1001 }}>&times;</button>
                {renderMedia(currentImage)}
              </div>
            </div>
          )}
    </div>
  );
}

export default CaseScores;
